<template>
  <div class="pt-container">
    <b-row>
      <b-col cols="5">
        <b-form-group>
          <div class="search-container">
            <Search class="icon" />
            <b-form-input
                class="placeholder-color"
                id="search"
                debounce="500"
                autocomplete="off"
                placeholder="Nome do produto, solicitante ou solicitação"
                v-model="filters.query"
            />
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-button variant="primary" class="mr-2" @click="searchProduct">Aplicar</b-button>
        <b-button variant="outline-primary" @click="openInfoSidebar()" class="button-wrapper">
          <FilterBar /> Filtros
          <div v-if="filterApplied" class="pulsating-circle"></div>
        </b-button>
      </b-col>
    </b-row>

    <SidebarFilter
        @change="updateFilter"
        @updateFilterApplied="updateFilterApplied"
    />

    <RequestsTable
        :productRequests="productRequests"
        :refresh="getProductStockRequests"
    />

    <div class="pagination-position">
      <b-pagination
          size="sm"
          v-model="page"
          :total-rows="count"
          :per-page="limit"
          first-number
          last-number
      />
    </div>

  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import api from "@/modules/warehouse/api";
import { getCurrentClinic, getCurrentUser } from '@/utils/localStorageManager'
import { EventBus } from '@/utils/eventBus'

export default {
  name: 'products-table',
  components: {
    RequestsTable: () => import('@/components/Warehouse/RequestsTable'),
    Search: () => import('@/assets/icons/search.svg'),
    FilterBar: () => import('@/assets/icons/filter-bar.svg'),
    SidebarFilter: () => import('./SidebarFilter.vue'),
  },
  props: {
    onProductEditClick: Function,
  },
  mounted () {
    if (this.$route.query.p === 'ls') {
      this.quantity = -1;
    }
    this.getProductStockRequests();

    EventBus.$on('refreshStockRequests', (message) => {
      this.getProductStockRequests();
    });
  },
  data() {
    return {
      clinic: getCurrentClinic(),
      user: getCurrentUser(),
      page: 1,
      limit: 15,
      count: 0,
      filters: {},
      productRequests: [],

      provider: null,
      providerQuery: null,
      start: null,
      end: null,
      quantity: null,
      products: [],
      providers: [],
      product: null,
      loading: false,
      hasFilter: false,
      filterApplied: false,
    }
  },
  methods: {
    handlePeriod(period) {
      this.start = period.start;
      this.end = period.end;
    },
    getProductStockRequests(hideLoading) {
      this.loading = true;

      let isLoading = null

      if(!hideLoading) {
        isLoading = this.$loading.show();
      }

      const params = {
        clinicId: this.clinic.id,
        filters: this.filters
      }

      api
          .getProductStockRequests(params)
          .then(res => {
            this.productRequests = res.data.data
            this.count = res.data.total
            this.limit = res.data.per_page
          })
          .catch(err => this.$toast.error(err.message))
          .finally(() => {
            isLoading && isLoading.hide()
          })
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    },
    getProductStockRequestsXlsx() {
      const isLoading = this.$loading.show();
      const data = {
        'query': this.filters,
        'provider': this.provider,
        'start': this.start,
        'end': this.end,
        'quantity': this.quantity
      }
      this.api.getProductStockRequestsExport(this.clinicId, data)
          .then(res => {
            saveAs(
                new Blob([res.data], {
                  type: 'application/vnd.ms-excel',
                }),
                'produtos.xlsx'
            );
          })
          .catch(err => this.$toast.error(err.message))
          .finally(() => isLoading.hide());
    },
    deleteProduct(product) {
      const isLoading = this.$loading.show();
      this.api.deleteProduct(product.id)
          .then(() => {
            this.$toast.success('Produto excluído com sucesso!');
            this.getProductStockRequests();
          })
          .catch(err => {
            this.$toast.error(err.message);
          })
          .finally(() => isLoading.hide());
    },
    getProviders() {
      this.api.getProviders(this.clinicId, 1, this.providerQuery)
          .then(res => {
            this.providers = res.data.data;
          })
          .catch(err => {
            console.log(err);
            this.$toast.error(err.message)
          });
    },
    openInfoSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')
    },
    async searchProduct() {
      this.currentPage = 1
      this.rows = [];
      this.getProductStockRequests();
    },
    async updateFilter(newFilter) {
      this.filters = newFilter
      this.currentPage = 1
      this.rows = [];
      this.getProductStockRequests();
    },
    async updateFilterApplied(){
      const filters = this.filters;

      for (var propName in filters) {
        if (filters[propName] === null || filters[propName] === undefined || filters[propName] === '') {
          delete filters[propName];
        }
      }

      delete filters.page;
      delete filters.type;

      this.filterApplied = Object.values(filters).length > 0;
    },
  },
  watch: {
    'filters.name': function() { this.getProductStockRequests(); },
    provider: function() { this.getProductStockRequests(); },
    start: function() { this.getProductStockRequests(); },
    quantity: function() { this.getProductStockRequests(); },
    page: function() { this.getProductStockRequests(); },
    providerQuery: function() { this.getProviders(); },
  }
}
</script>
<style scoped lang="scss">
.pt-container {
  padding: 30px 10px;

  .pulsating-circle {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    background-color: var(--orange);
    border-radius: 50%;
    width: 10px;
    height: 10px;
  }

  .pt-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 30px 0;
  }
  .pt-title {
    display: inline-flex;
    align-items: center;
    font-family: 'Red Hat Display';
    font-weight: 500;
    font-size: 18px;
  }

  .placeholder-color::placeholder {
    color: var(--type-placeholder);
  }

  .wh-button {
    margin: 0 0 0 10px;
    border-color: var(--blue-500);
    color: var(--blue-500);
  }
  .icon {
    height: 24px;
    width: 24px;
    margin-left: 5px;
    stroke: var(--neutral-500);
  }
  .pagination-position {
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
  }
  label {
    width: 100%;
    font-family: 'Nunito Sans';
    font-weight: 700;
    font-size: 16px;
    color: #525C7A;
    text-align: left !important;
    color: var(--dark-blue);
    margin-bottom: 4px;
  }

  .search-container {
    display: flex;
    flex-direction: row;
    position: relative;
    .icon {
      position: absolute;
      width: 24px;
      height: 24px;
      stroke: var(--neutral-500);
      height: 100%;
      margin-left: 10px;
    }

    input {
      padding-left: 40px !important;
    }
  }
}
</style>
